var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "54px",
    height: "54px",
    viewBox: "0 0 54 54",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Trophy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trophy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(7, 7)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6666667,18 L5.33333333,18 C2.38918539,17.9966934 0.0033065897,15.6108146 0,12.6666667 L0,4.66666667 L10.6666667,4.66666667 L10.6666667,7.33333333 L2.66666667,7.33333333 L2.66666667,12.6666667 C2.66666667,14.139426 3.860574,15.3333333 5.33333333,15.3333333 L10.6666667,15.3333333 L10.6666667,18 Z",
    id: "Path",
    fill: "#C4A831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6666667,18 L29.3333333,18 L29.3333333,15.3333333 L34.6666667,15.3333333 C36.139426,15.3333333 37.3333333,14.139426 37.3333333,12.6666667 L37.3333333,7.33333333 L29.3333333,7.33333333 L29.3333333,4.66666667 L40,4.66666667 L40,12.6666667 C39.9966934,15.6108146 37.6108146,17.9966934 34.6666667,18 L34.6666667,18 Z",
    id: "Path",
    fill: "#C4A831"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D1B230",
    x: 17.3333333,
    y: 24,
    width: 5.33333333,
    height: 9.33333333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2666667,28 L19.8666667,28 C12.5856252,27.9780359 6.68863074,22.0810415 6.66666667,14.8 L6.66666667,2 C6.66666667,0.8954305 7.56209717,0 8.66666667,0 L31.3333333,0 C32.4379028,0 33.3333333,0.8954305 33.3333333,2 L33.3333333,14.9333333 C33.3333333,22.1498541 27.4831874,28 20.2666667,28 Z",
    id: "Path",
    fill: "#E5C645"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C4A831",
    points: "20 4.66666667 22.2146667 9.154 27.166 9.87333333 23.5833333 13.366 24.4286667 18.2973333 20 15.9693333 15.5713333 18.2973333 16.4166667 13.366 12.834 9.87333333 17.7853333 9.154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,40 L12,40 L12,38 C12,36.8954305 12.8954305,36 14,36 L26,36 C27.1045695,36 28,36.8954305 28,38 L28,40 Z",
    id: "Path",
    fill: "#E5C645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6666667,36 L15.3333333,36 L15.3333333,34 C15.3333333,32.8954305 16.2287638,32 17.3333333,32 L22.6666667,32 C23.7712362,32 24.6666667,32.8954305 24.6666667,34 L24.6666667,36 Z",
    id: "Path",
    fill: "#E5C645"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/Trophy.47a16b600c76c926a59410729cd27b68.svg";
export { ForwardRef as ReactComponent };